/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".multiline-tooltip{white-space:pre-line}.custom-tooltip{font-size:12px;background-color:var(--background-tablerowselect)!important;color:var(--foreground-tablerowselect)!important;max-width:unset!important}"];
export { styles as styles };
